import { styled } from '@naan/stitches.config';

export const Card = styled('div', {
  background: '$colors$gray-25',
  borderRadius: '12px',
  padding: '16px 20px 20px',
});
